// Replaced in dist output by the prepack script (must match its sed
// pattern); source builds and tests keep the placeholder value.
export const version = '0.0.0-inject-version-here'
